const frontendUrl = import.meta.env.VITE_FRONTEND_URL ?? "https://list.abunny.net";

export const config = {
  apiBaseUrl:
    import.meta.env.VITE_API_BASE_URL ?? "https://2w6eo1vac2.execute-api.us-west-2.amazonaws.com",
  cognitoDomain:
    import.meta.env.VITE_COGNITO_DOMAIN ??
    "https://shopping-list-auth.auth.us-west-2.amazoncognito.com",
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID ?? "30v57d066218el32onv7vic2ds",
  redirectUri: import.meta.env.VITE_REDIRECT_URI ?? frontendUrl
};

export function buildLoginUrl(state: string): string {
  const baseUrl = `${config.cognitoDomain}/oauth2/authorize?identity_provider=Google&redirect_uri=${encodeURIComponent(
    config.redirectUri
  )}&response_type=token&client_id=${config.userPoolClientId}&scope=openid%20email%20profile`;

  return state ? `${baseUrl}&state=${encodeURIComponent(state)}` : baseUrl;
}
